import gql from 'graphql-tag';

export default gql`
  mutation addChannelRelationship($relationship: ChannelRelationshipInput!) {
    addChannelRelationship(relationship: $relationship) {
      _id
    }
  }
`;
